import { request } from '../../utils/api.js'

const state = {
  resource_list: [],
  loading: false,
  resource_id: null,
  user_list: []
}

const actions = {
  async listBoxes({ commit, state }) {
    if (JSON.stringify(state.resource_list) !== '[]') return

    commit('setLoading', { loading: true })

    const boxes = await request({
      verb: 'GET',
      route: '/api/otherResources'
    })
      .then(res => res.data)
      .catch(err => console.error(err))

    commit('setBoxList', { boxes })
    commit('setLoading', { loading: false })
  },

  async retrieveResourceUserList({ commit, state }) {
    if (JSON.stringify(state.user_list) !== '[]') return

    commit('setLoading', { loading: true })

    const users = await request({
      verb: 'GET',
      route: `/api/otherResources/${state.resource_id}/users`
    })
      .then(res => res.data)
      .catch(err => console.error(err))

    commit('setUsers', { users: users ?? [] })
    commit('setLoading', { loading: false })
  }
}

const mutations = {
  setBoxList(state, { boxes }) {
    state.resource_list = boxes
  },
  setUsers(state, { users }) {
    state.user_list = users
  },
  setResourceID(state, { id }) {
    if (state.resource_id !== id) {
      state.resource_id = id
      state.user_list = []
    }
  },
  setLoading(state, { loading }) {
    state.loading = loading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}